
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PrivacyRadioGroup extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ required: true }) description!: string[];
  @Prop({ required: true }) consentText!: string;
  @Prop({ required: true }) noConsentText!: string;
}
